import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Userright, UserroleApi, UserroleRight, UserroleRightApi } from './userrole';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import { UserRole } from '../user/user';

@Injectable({ providedIn: 'root' })
export class UserroleService {
    constructor(
        private readonly http: HttpClient,
        @Inject(API_BASE_URL_SERVICE) private readonly apiBaseUrl: string,
    ) {}

    getAllUserroles(): Observable<UserroleApi> {
        return this.http.get<UserroleApi>(this.apiBaseUrl + 'benutzerrolle/read.php');
    }

    getUserroleRights(role: UserRole): Observable<UserroleRightApi> {
        return this.http.get<UserroleRightApi>(
            this.apiBaseUrl + 'benutzerrolle_benutzerrecht/read.php?benutzerrolle_id=' + role.benutzerrolle_id,
        );
    }

    addRightToRole(role: UserRole, right: Userright) {
        const userroleRight: UserroleRight = new UserroleRight();
        userroleRight.benutzerrolle_id = role.benutzerrolle_id;
        userroleRight.benutzerrecht_id = right.benutzerrecht_id;
        return this.http.post(this.apiBaseUrl + 'benutzerrolle_benutzerrecht/create.php', userroleRight);
    }

    removeRightFromRole(role: UserRole, right: Userright) {
        const userroleRight = new UserroleRight();
        userroleRight.benutzerrolle_id = role.benutzerrolle_id;
        userroleRight.benutzerrecht_id = right.benutzerrecht_id;
        return this.http.post(this.apiBaseUrl + 'benutzerrolle_benutzerrecht/delete.php', userroleRight);
    }
}
